/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BattleAdminParticipantDto = {
  /**
   * 유저 ID
   */
  userId: number;
  /**
   * 닉네임
   */
  nickname: string | null;
  /**
   * 프로필 이미지
   */
  profileImageUrl: string | null;
  /**
   * 참여 상태
   */
  status: BattleAdminParticipantDto.status;
  /**
   * 참여 시각
   */
  joinedAt: string;
  /**
   * 완주 시각 (null = 미완주)
   */
  completedAt: string | null;
  /**
   * 총 정답수 (완주 시 스냅샷)
   */
  correctCount: number | null;
  /**
   * 총 소요시간(초) (완주 시 스냅샷)
   */
  totalTimeSeconds: number | null;
  /**
   * 완주 시 적립된 기본 마일리지
   */
  baseMileageEarned: number | null;
  /**
   * 순위 (정산 시 채워짐)
   */
  rank: number | null;
  /**
   * 지급 상금 (정산 시 채워짐)
   */
  prizeAmount: number | null;
};
export namespace BattleAdminParticipantDto {
  /**
   * 참여 상태
   */
  export enum status {
    JOINED = "JOINED",
    COMPLETED = "COMPLETED",
  }
}
